import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { ContatoIniciativaPipeModule } from '../../pipes';

import { ContatoIniciativaCardControlRadioComponent } from './contato-iniciativa-card-control-radio.component';

@NgModule({
    imports: [
        SharedModule,
        ContatoIniciativaPipeModule
    ],
    declarations: [
        ContatoIniciativaCardControlRadioComponent
    ],
    exports: [
        ContatoIniciativaCardControlRadioComponent
    ]
})
export class ContatoIniciativaCardControlRadioModule { }
